import { DesignStudio } from 'shared/constants/FeatureFlag';
import { useTreatment } from 'shared/hooks';

export const useDesignVersioning = () =>
  useTreatment(DesignStudio.DESIGN_VERSIONING) === 'on';
